import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#111111",
    },
    text: {
      primary: "#111111",
      secondary: "rgba(17, 17, 17, 0.5)",
      inactive: "rgba(17, 17, 17, 0.5)", // ONLY NEW LINE ADDED
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Arial",
      "sans-serif",
    ].join(","),
    fontSize: "2vw",
    h1: {
      letterSpacing: "-0.02em",
      marginTop: 0,
      marginBottom: 0,
      fontSize: "1.5em",
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h2: {
      letterSpacing: "-0.02em",
      marginTop: 0,
      marginBottom: 0,
      fontSize: "1.1em",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h3: {
      letterSpacing: "-0.015em",
      marginTop: 0,
      marginBottom: 0,
      fontSize: ".9em",
      fontWeight: 500,
      lineHeight: 1,
    },
    h4: {
      letterSpacing: "-0.01em",
      marginTop: 0,
      marginBottom: 0,
      fontSize: ".8em",
      fontWeight: 500,
      lineHeight: 1,
    },
    h5: {
      marginTop: 0,
      marginBottom: 0,
      fontSize: "1em",
      fontWeight: 500,
      lineHeight: 1,
    },
    h6: {
      textTransform: "uppercase",
      marginTop: 0,
      marginBottom: 0,
      fontSize: "0.75em",
      fontWeight: 300,
      lineHeight: 1,
    },
    body1: {
      fontSize: "0.6em",
      marginBottom: 0,
    },
    body2: {
      fontSize: "0.65em",
      lineHeight: 1.8,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 479,
      md: 767,
      lg: 991,
      xl: 1440, // Changed from 1920 to a more common large screen width
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          color: "#222222",
          backgroundColor: "#fff",
          fontFamily: "Inter, sans-serif",
          fontSize: "1.5625rem",
          lineHeight: 1.5,
          minHeight: "100%",
        },
      },
    },
    // MuiLink: {
    //   defaultProps: {
    //     underline: "none",
    //   },
    //   styleOverrides: {
    //     root: {
    //       textDecoration: "none",
    //       "&:hover": {
    //         textDecoration: "none",
    //       },
    //     },
    //   },
    //   // ONLY NEW ADDITION BELOW
    //   variants: [
    //     {
    //       props: { variant: "nav" },
    //       style: {
    //         opacity: 0.5,
    //         transition: "opacity 0.3s",
    //         "&:hover, &.active": {
    //           opacity: 1,
    //         },
    //       },
    //     },
    //   ],
    // },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "0.3em",
          fontSize: "0.9em",
          padding: "1em 1.5em",
          lineHeight: 1,
          transition: "background-color 0.3s",
        },
        contained: {
          backgroundColor: "#222222",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#444444",
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          "@media (min-width: 767px)": {
            // paddingLeft: "10%",
            // paddingRight: "10%",
          },
        },
      },
    },
  },
});

// Responsive typography
theme.typography.h1 = {
  ...theme.typography.h1,
  [theme.breakpoints.down("md")]: {
    fontSize: "1.3em",
  },
};

theme.typography.h2 = {
  ...theme.typography.h2,
  [theme.breakpoints.down("md")]: {
    fontSize: "1.4em",
  },
};

// Additional responsive styles
theme.components.MuiCssBaseline.styleOverrides = {
  ...theme.components.MuiCssBaseline.styleOverrides,
  "@media (min-width: 1440px)": {
    // Add this block
    body: {
      fontSize: "1.75rem",
    },
  },
  "@media (max-width: 767px)": {
    body: {
      fontSize: "1.875rem",
    },
  },
  "@media (max-width: 479px)": {
    body: {
      fontSize: "2.1875rem",
    },
  },
};

export default theme;
